import React, { useState } from 'react';
import axios from 'axios';
import '../styles/DataDeletion.css';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const DataDeletionRequest = () => {
  const [formData, setFormData] = useState({
    email: '',
    name: '',
    reason: '',
    confirmEmail: ''
  });
  const [status, setStatus] = useState({ submitted: false, message: '', isError: false });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ submitted: false, message: '', isError: false });

    // Validation
    if (formData.email !== formData.confirmEmail) {
      setStatus({ 
        submitted: true, 
        message: 'Les adresses courriel ne correspondent pas.', 
        isError: true 
      });
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${API_URL}/api/data-deletion-request`, {
        email: formData.email,
        name: formData.name,
        reason: formData.reason
      });

      setStatus({
        submitted: true,
        message: response.data.message,
        isError: false
      });

      // Reset form
      setFormData({ email: '', name: '', reason: '', confirmEmail: '' });
    } catch (error) {
      setStatus({
        submitted: true,
        message: error.response?.data?.detail || 'Une erreur est survenue. Veuillez réessayer.',
        isError: true
      });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="data-deletion-page">
      <div className="data-deletion-container">
        <h1>Demande de suppression de données</h1>
        
        <div className="data-deletion-intro">
          <p>
            Conformément à la <strong>Loi 25 du Québec</strong>, vous avez le droit de demander 
            la suppression de vos renseignements personnels que nous détenons.
          </p>
          <p>
            Complétez le formulaire ci-dessous et nous traiterons votre demande dans les 
            <strong> 30 jours ouvrables</strong>.
          </p>
        </div>

        {status.submitted && (
          <div className={`data-deletion-alert ${status.isError ? 'alert-error' : 'alert-success'}`}>
            {status.message}
          </div>
        )}

        <form onSubmit={handleSubmit} className="data-deletion-form">
          <div className="form-group">
            <label htmlFor="name">Nom complet *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Prénom et nom"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Adresse courriel *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="votre@courriel.com"
            />
            <span className="field-hint">
              L'adresse utilisée lors de votre soumission ou communication avec nous
            </span>
          </div>

          <div className="form-group">
            <label htmlFor="confirmEmail">Confirmer l'adresse courriel *</label>
            <input
              type="email"
              id="confirmEmail"
              name="confirmEmail"
              value={formData.confirmEmail}
              onChange={handleChange}
              required
              placeholder="votre@courriel.com"
            />
          </div>

          <div className="form-group">
            <label htmlFor="reason">Raison de votre demande (optionnel)</label>
            <textarea
              id="reason"
              name="reason"
              value={formData.reason}
              onChange={handleChange}
              rows="4"
              placeholder="Vous pouvez nous indiquer pourquoi vous souhaitez supprimer vos données..."
            />
          </div>

          <div className="data-deletion-info">
            <h3>⚠️ Important</h3>
            <ul>
              <li>La suppression de vos données est <strong>irréversible</strong></li>
              <li>Nous supprimerons toutes vos informations personnelles, y compris :
                <ul>
                  <li>Vos coordonnées (nom, adresse, courriel, téléphone)</li>
                  <li>Les détails de votre propriété et terrain</li>
                  <li>Les photos et notes que vous avez partagées</li>
                  <li>L'historique de vos demandes de soumission</li>
                </ul>
              </li>
              <li>Certaines données peuvent être conservées si requis par la loi (ex: obligations fiscales)</li>
              <li>Vous recevrez une confirmation par courriel une fois la suppression effectuée</li>
            </ul>
          </div>

          <div className="form-actions">
            <button 
              type="submit" 
              disabled={loading}
              className="submit-btn"
            >
              {loading ? 'Envoi en cours...' : 'Soumettre ma demande'}
            </button>
            <a href="/" className="cancel-link">Annuler</a>
          </div>
        </form>

        <div className="data-deletion-contact">
          <h3>Questions ou préoccupations ?</h3>
          <p>
            Si vous avez des questions concernant vos droits ou cette demande, 
            contactez-nous :
          </p>
          <p>
            <strong>Email :</strong> <a href="mailto:info@nvfertilisation.com">info@nvfertilisation.com</a><br />
            <strong>Téléphone :</strong> <a href="tel:4502101858">450 210 1858</a>
          </p>
        </div>

        <div className="data-deletion-footer">
          <a href="/privacy-policy">Consulter notre politique de confidentialité</a>
        </div>
      </div>
    </div>
  );
};

export default DataDeletionRequest;
